<template>
<div class="chapter">
<div class="inner_page">
<p class="C156"><span class="size_160"><span id="page_v">Contents</span></span></p>
<p class="C156"><a href="#/xhtml/06_Preface#page_vii">Preface</a></p>
<p class="C194"><a href="#/xhtml/07_1_Old_Qu#page_1">1. Old Questions</a></p>
<p class="C160"><a href="#/xhtml/08_2_The_Ac#page_23">2. The Academies of Secrets</a></p>
<p class="C160"><span href="#/xhtml/09_3_The_Th#page_49" title="Link target outside of Sample">3. The Theatre of Curiosity</span></p>
<p class="C160"><span href="#/xhtml/10_4_The_Hu#page_85" title="Link target outside of Sample">4. The Hunt of Pan</span></p>
<p class="C160"><span href="#/xhtml/11_5_Profes#page_113" title="Link target outside of Sample">5. Professors of Everything</span></p>
<p class="C160"><span href="#/xhtml/12_6_More_T#page_145" title="Link target outside of Sample">6. More Things in Heaven and Earth</span></p>
<p class="C160"><span href="#/xhtml/13_7_Cosmic#page_175" title="Link target outside of Sample">7. Cosmic Disharmonies</span></p>
<p class="C160"><span href="#/xhtml/14_8_The_Fi#page_215" title="Link target outside of Sample">8. The First Men in the Moon</span></p>
<p class="C160"><span href="#/xhtml/15_9_Nature#page_256" title="Link target outside of Sample">9. Nature Free and Bound</span></p>
<p class="C160"><span href="#/xhtml/16_10_On_th#page_287" title="Link target outside of Sample">10. On the Head of a Pin</span></p>
<p class="C160"><span href="#/xhtml/17_11_The_L#page_321" title="Link target outside of Sample">11. The Light of Nature</span></p>
<p class="C160"><span href="#/xhtml/18_12_Chasi#page_353" title="Link target outside of Sample">12. Chasing Elephants</span></p>
<p class="C162"><span href="#/xhtml/19_13_Profe#page_389" title="Link target outside of Sample">13. Professional Virtuosi, or Curiosity Served Cold</span></p>
<p class="C194"><em><span href="#/xhtml/20_Cast_of#page_411" title="Link target outside of Sample">Cast of Characters</span></em></p>
<p class="C160"><em><span href="#/xhtml/21_Notes#page_419" title="Link target outside of Sample">Notes</span></em></p>
<p class="C160"><em><span href="#/xhtml/22_Bibliogr#page_445" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C160"><em><span href="#/xhtml/23_Image_Cr#page_455" title="Link target outside of Sample">Image Credits</span></em></p>
<p class="C162"><em><span href="#/xhtml/24_Index#page_457" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?6a60c674